// extracted by mini-css-extract-plugin
var _1 = "HomeworkAllCompleteModal__illustration--XO97q";
var _2 = "HomeworkAllCompleteModal__illustrationWrap--j2uLl";
export { _1 as "illustration", _2 as "illustrationWrap" }
